import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { SurveyAnswerRepositoryImpl } from "../../data/repository/survey_answer_repository_impl";
import { AnswerInterface } from "../interfaces/answer_interface";
import { SurveyInterface } from "../interfaces/survey_interface";

interface ModifyAnswerQuestionProps {
    answer: AnswerInterface;
    answerId: string;
    surveyId: string;
}

export const useModifyAnswer = () => {
    const repository = new SurveyAnswerRepositoryImpl();
    const queryClient = useQueryClient();

    return useMutation<AnswerInterface | undefined, AxiosError, ModifyAnswerQuestionProps>({
        mutationFn: ({ answer, answerId }) => repository.modifyAnswer(answer, answerId),
        onSuccess: (newAnswer, { surveyId }) => {
            if (newAnswer) {
                queryClient.setQueryData<SurveyInterface | null>(['survey', surveyId], (old) => {
                    if (!old) return old;
                    const questions = old.questions.map(q =>
                        q.id === newAnswer.questionId ? { ...q, initialAnswer: newAnswer } : q
                    );
                    return { ...old, questions };
                });
            }
            queryClient.invalidateQueries({ queryKey: ['surveysList'] });
            queryClient.invalidateQueries({ queryKey: ['surveyStatistics', surveyId] });
        },
    });
};
